import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  return <section className="relative py-32 px-6 overflow-hidden bg-black" data-id="element-33">
      {/* Dramatic Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#D4AF37]/5 to-[#D4AF37]/10 pointer-events-none" data-id="element-34" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#D4AF37]/20 blur-[150px] rounded-full pointer-events-none" data-id="element-35" />

      {/* Animated Particles (CSS only via background pattern) */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20 animate-pulse-glow pointer-events-none" data-id="element-36" />

      <div className="relative z-10 max-w-4xl mx-auto text-center glass-card p-12 md:p-24 border-[#D4AF37]/20 shadow-[0_0_50px_rgba(212,175,55,0.1)] overflow-hidden" data-id="element-37">
        {/* Inner glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-gold opacity-50" data-id="element-38" />

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 tracking-tight" data-id="element-39">
          Ready to build something <br className="hidden md:block" data-id="element-40" />
          <span className="text-gradient-gold" data-id="element-41">exceptional?</span>
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-42">
          Partner with us to transform your Shopify store into a
          high-converting, premium digital experience.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-43">
          <Link to="/contact" className="inline-flex items-center justify-center gap-3 bg-gradient-gold text-black px-12 py-5 rounded-full font-bold text-lg gold-glow-hover transition-all duration-300 hover:scale-105 group" data-id="element-44">
            Start Your Project
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-45" />
          </Link>

          <Link to="/portfolio" className="text-gray-400 hover:text-[#D4AF37] font-medium transition-colors border-b border-transparent hover:border-[#D4AF37] pb-0.5" data-id="element-46">
            Or view our recent work
          </Link>
        </div>
      </div>
    </section>;
}